<template>
  <div>
    <div class="header-container" :style="{ 'background-color': backgroundColor }">
      <div class="header-content">
        <div class="back-to-home" @click="backToHome">
          <i class="bi bi-chevron-left"></i> {{ getTranslatedText("live number draws") }}
        </div>
        <Clock class="header-clock" />
      </div>
    </div>
    <Navbar />
    <Banner v-if="currentGame" :bannerImages="bannerImages" :currentGame="currentGame" />
  </div>
</template>

<script>
import languageMixins from "@/mixins/language-mixins";

import Navbar from "./navbar.vue";
import Banner from "./banner.vue";
import Clock from "../Clock.vue";
import PromotionsService from "@/services/promotions/index.service";

export default {
  mixins: [languageMixins],
  components: { Navbar, Banner, Clock },
  data() {
    return {
      bannerImages: [],
      backgroundColor: '',
      currentGame: ''
    };
  },
  watch: {
    "$store.state.gameSettings"() {
      this.handleGetConfigHeader(this.$route.params.gameSlug);
    },
  },
  created() {
    this.unregisterBeforeRouteUpdate = this.$router.afterEach((to) => {
      this.currentGame = to.params.gameSlug;
      this.handleGetConfigHeader(to.params.gameSlug);
    });
    this.handleGetConfigHeader(this.$route.params.gameSlug);
  },
  unmounted() {
    if (this.unregisterBeforeRouteUpdate) {
      this.unregisterBeforeRouteUpdate();
    }
  },
  methods: {
    handleGetConfigHeader(gameSlug) {
      if (!gameSlug) return;
      const settings = this.$store.state.gameSettings || {};
      const gameSetting = settings.gameSetting;
      if (!gameSetting) return;
      const urlImage = process.env.VUE_APP_IMAGE_URL;
      let config = gameSetting[gameSlug];

      const detailBanners = Object.entries(gameSetting).map(([key, game]) => ({
        banner: urlImage + game.detailBanner,
        bannerMobile: urlImage + game.detailBannerMobile,
        slug: key,
      }));
      this.currentGame = gameSlug;
      this.bannerImages = detailBanners;

      if (config) {
        this.backgroundColor = config.headerColor;
      } else {
        this.backgroundColor = settings.headerColor;
      }

      this.getCustomerPromoStatus();

    },
    backToHome() {
      const query = this.$route.query;
      this.$router.push({ path: "/", query });
      this.$store.commit("setMarketSelected", null);
    },

    async getCustomerPromoStatus() {
      try {
        let res = await PromotionsService.checkCustomerPromos();
        if(res.result.count){
          this.$store.commit("setFreeBetCount", res.result.count)
        } else {
          this.$store.commit("setFreeBetCount", 0)
          // Clear localStorage when count is 0 to allow popup to show again when user gets new free bets
          localStorage.removeItem('showPromoPopUp');
        }
      } catch (error) {
        console.log(error);
      }
    },
  }
};
</script>

<style lang="scss">
@import "@/public/scss/common/header/index.scss";

.header-container {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  max-height: 60px;
}

.back-to-home {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 18px;
  color: #fff;
}

.header-clock {
  font-size: 18px;
  color: #fff;
}

@media (max-width: 768px) {
  .header-content {
    padding: 4px;
    font-size: 14px;
  }
}
</style>
